module.exports = __webpack_public_path__ + "static/assets/33e9ab69053073088ec88cf78f3a676b.svg";